import React from "react"

const ContactManagement = ({ className = "", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M13.3333 17.3333C17.0152 17.3333 20 14.3486 20 10.6667C20 6.98477 17.0152 4 13.3333 4C9.65144 4 6.66667 6.98477 6.66667 10.6667C6.66667 14.3486 9.65144 17.3333 13.3333 17.3333Z"
        stroke="#463DFB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66666 28C2.66682 26.3213 3.06319 24.6663 3.82354 23.1697C4.58389 21.673 5.68675 20.377 7.04243 19.3869C8.39811 18.3969 9.96832 17.7407 11.6254 17.4719C13.2824 17.2032 14.9795 17.3293 16.5787 17.84"
        stroke="#463DFB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 28C26.2091 28 28 26.2091 28 24C28 21.7909 26.2091 20 24 20C21.7909 20 20 21.7909 20 24C20 26.2091 21.7909 28 24 28Z"
        stroke="#463DFB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3333 29.3333L26.8 26.8"
        stroke="#463DFB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ContactManagement
